import React, { useCallback, useMemo } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { Waypoint } from 'react-waypoint';

import { useFeatures } from '@atc/features';

import refreshFixedAd from '@/utilities/refreshFixedAd';

import srpFixedAdDuck from '@/ducks/srp/srpFixedAdDuck.js';

import DisableAdsFeatureFlag from '@/containers/global/DisableAdsFeatureFlag';

export function FixedAdWaypointContainer({
    cmp,
    onLeave,
    onEnter,
    onPositionChange,
}) {
    const { fixed_ads: [, { slot_id: slotId }] } = useFeatures(['fixed_ads']);
    const dispatch = useDispatch();
    const refreshCount = useSelector(srpFixedAdDuck.selectors.getRefreshCount);

    const actions = useMemo(() => ({
        showFixedAd: () => dispatch(srpFixedAdDuck.creators.setKeys({
            showFixedAd: true,
        })),
        hideFixedAd: () => dispatch(srpFixedAdDuck.creators.setKeys({
            showFixedAd: false,
        })),
        refreshFixedAd: (adPos) => dispatch(srpFixedAdDuck.creators.setKeys({
            adPos,
        })),
        setRefreshCount: () => {
            refreshFixedAd({ dispatch, refreshCount, slotId });
        },
    }), [dispatch, refreshCount, slotId]);

    const handleOnLeave = useCallback((props) => {
        if (onLeave) {
            onLeave({ actions, ...props });
        }
    }, [actions, onLeave]);

    const handleOnEnter = useCallback((props) => {
        if (onEnter) {
            onEnter({ actions, ...props });
        }
    }, [actions, onEnter]);

    const handleOnPositionChange = useCallback((props) => {
        if (onPositionChange) {
            onPositionChange({ actions, ...props });
        }
    }, [actions, onPositionChange]);

    const dataCmp = `${cmp}FixedAdTrigger`;

    return (
        <DisableAdsFeatureFlag>
            <Waypoint
                data-cmp={dataCmp}
                onLeave={handleOnLeave}
                onEnter={handleOnEnter}
                onPositionChange={handleOnPositionChange}
            />
        </DisableAdsFeatureFlag>
    );
}

export default FixedAdWaypointContainer;
